(function ($) {
    $(document).ready(function() {


        //* When clicking toggle button, show/hide the menus and reset toggle states
        $('.menu-toggle').click(function() {
            if ($(this).hasClass('toggled')) {
                $(this).removeClass('toggled');
                $('.menu-primary-container').removeClass('show');
                $('.menu-primary-spanish-container').removeClass('show');
                $('.menu-item-has-children').removeClass('toggled');
            } else {
                $(this).addClass('toggled');
                $('.menu-primary-container').addClass('show');
                $('.menu-primary-spanish-container').addClass('show');
            }
        });

        //* Toggles the current menu item and resets others
        $('.menu-item-has-children').click(function() {
            $(this).toggleClass('toggled');
            $(this).siblings().removeClass('toggled');
        });

        //* Resets the mobile menu show/hide/toggles
        $(window).resize(function() {
            if ($(window).width() > 991) {
                $('.navigation-wrapper').find('.show').each(function() {
                    $(this).removeClass('show');
                });

                $('.navigation-wrapper').find('.toggled').each(function() {
                    $(this).removeClass('toggled');
                }); 
            }
        });

        var cta = $('#utility-navigation').find('.cta'); 
        $(cta).find('a').clone().addClass('cta-top').prependTo('.site-header');

        //* Remove click functionality for top level menu link dropdowns
        $('.menu-item-has-children > a').click(function(e) {
            e.preventDefault();
        });

        //* Clones the first menu item so we can actually click on it in the sub menu that opens
        $('#primary-menu').find('.menu-item-has-children > a:first-child').each(function() {
            var submenu = $(this).next();
            $(this).first().clone().addClass('cloned').prependTo(submenu);
        });

        //* Now, wrap the cloned item in wordpress menu item li/classes and change the text to "Overview"
        var overview_text = translation_data.overview_text;
        $('.cloned').each(function() {
            $(this).wrap('<li class="menu-item menu-item-type-post_type menu-item-object-page"></li>').text(overview_text);
        });
    });
}(jQuery));